const __vitePreload = (fn) => fn();
import { generateUUID } from "@wix/form-schema";
import { useState, useEffect } from "react";
const useAtlas = ({
  enabled,
  getInstance,
  language,
  locale,
  atlasBaseUrl
}) => {
  const [atlas, setAtlas] = useState();
  const instance = getInstance();
  const [sessionToken, setSessionToken] = useState(generateUUID());
  const refreshSessionToken = () => setSessionToken(generateUUID());
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const initAtlas = async () => {
      try {
        const { createAtlasService } = await __vitePreload(async () => {
          const { createAtlasService: createAtlasService2 } = await import(
            /* webpackChunkName: "atlas-service" */
            "./atlas-service.js"
          );
          return { createAtlasService: createAtlasService2 };
        }, true ? [] : void 0);
        const atlasService = createAtlasService({
          getInstance: () => instance,
          sessionToken,
          refreshSessionToken,
          language,
          locale,
          atlasBaseUrl
        });
        setAtlas(atlasService);
      } catch (_error) {
      }
    };
    initAtlas();
  }, [enabled, instance, language, locale, sessionToken, atlasBaseUrl]);
  return atlas;
};
export {
  useAtlas
};
//# sourceMappingURL=use-atlas.js.map
